import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private _isLoading: boolean = false;
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();

  constructor() {}

  get loading(): boolean {
    return this._isLoading;
  }

  show() {
    document.querySelector('body')?.classList.add('overflow-hidden');
    const loader = document.querySelector('#loader');
    loader?.classList.remove('fade-out');
    this._isLoading = true;
    this.isLoadingSubject.next(true);
  }

  hide() {
    setTimeout(() => {
      document.querySelector('body')?.classList.remove('overflow-hidden');
      const loader = document.querySelector('#loader');
      loader?.classList.add('fade-out');
      this._isLoading = false;
      this.isLoadingSubject.next(false);
    }, 500);
  }
}

export function LoaderFactory(loader: LoaderService) {
  return () => loader.show();
}
